'use client';

import { FC } from 'react';

import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/navigation';

import { PATH } from '@screens/Category';
import { CLOSET_PATH, MIRRORS_PATH, PEDESTAL_PATH } from '@shared/constants/catalog';
import { ROUTES } from '@shared/constants/routes';
import { Container } from '@shared/ui/Container';
import { SectionTitle } from '@shared/ui/SectionTitle';
import img3 from '@widgets/CategoriesMenu/images/closets.png';
import img2 from '@widgets/CategoriesMenu/images/mirrors.png';
import img1 from '@widgets/CategoriesMenu/images/pedestals.jpg';

import cls from './ProductCategories.module.scss';

type ProductCategoriesProps = {
  hideTitle?: boolean;
};

export const ProductCategories: FC<ProductCategoriesProps> = ({ hideTitle }) => {
  const { push } = useRouter();

  const handleClickTitle = () => {
    push(ROUTES.CATALOG);
  };

  return (
    <section className={cls.section}>
      <Container>
        {!hideTitle && (
          <SectionTitle
            tag={'h1'}
            onClick={handleClickTitle}
          >
            Каталог
          </SectionTitle>
        )}
        <div className={cls.categories}>
          <Link
            aria-label={'Перейти в категорию Тумбы'}
            href={PATH[PEDESTAL_PATH].url}
            className={cls.category}
          >
            <div className={cls.image}>
              <Image
                fill
                src={img1}
                alt={'Тумба для ванной комнаты'}
                priority
              />
            </div>
            <div className={cls.categoryTitle}>Тумбы</div>
          </Link>
          <Link
            aria-label={'Перейти в категорию Зеркала'}
            href={PATH[MIRRORS_PATH].url}
            className={cls.category}
          >
            <div className={cls.image}>
              <Image
                fill
                src={img2}
                alt={'Зеркало из коллекции мебели для ванной комнаты'}
                priority
              />
            </div>
            <div className={cls.categoryTitle}>Зеркала</div>
          </Link>
          <Link
            aria-label={'Перейти в категорию Шкафы'}
            href={PATH[CLOSET_PATH].url}
            className={cls.category}
          >
            <div className={cls.image}>
              <Image
                fill
                src={img3}
                alt={'Шкаф из комплекта мебели для ванной и туалета'}
                priority
              />
            </div>
            <div className={cls.categoryTitle}>Шкафы</div>
          </Link>
        </div>
      </Container>
    </section>
  );
};
